import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
import {Panel, PanelItem} from '../../../components'
import Typography from 'material-ui/Typography'
import IconButton from 'material-ui/IconButton'
import KeyboardArrowDownicon from 'material-ui-icons/KeyboardArrowDown'
import Dialog, {DialogTitle, DialogActions} from 'material-ui/Dialog'
import List, {ListItem, ListItemText} from 'material-ui/List'
import {Link} from '../index'
import Button from 'material-ui/Button'
import {LoadingIndicator} from '../../../components'

const styles = theme => ({
  wrapper: {
    position: 'relative',
  },
  Container: {
    width: '100%',
  },
  TitleContainer: {
    width: '100%', display: 'flex',
  },
  LastActionContainer: {
    padding: '5px 16px',
  },
  loadingIndicator: {
    color: theme.palette.secondary.main,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  loadingBackdrop: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    background: 'rgba(255, 255, 255, .65)',
    borderRadius: 5,
  },
})

class Selector extends React.PureComponent {

  static propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onOpen: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.any.isRequired,
      disabled: PropTypes.bool,
    })),
    value: PropTypes.any,
    onSelect: PropTypes.func,
    onCancel: PropTypes.func,
    lastAction: PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
    }),
    title: PropTypes.string,
    modalTitle: PropTypes.string,
    defaultLabel: PropTypes.string,
    isLoading: PropTypes.bool,
  }

  static defaultProps = {
    options: [],
    value: '',
    onSelect: () => {},
    onCancel: () => {},
    lastAction: null,
    title: 'Seleccionado',
    modalTitle: 'Opciones',
    defaultLabel: '',
    isLoading: false,
  }

  constructor(props) {
    super(props)

    this.state = {
      label: props.defaultLabel,
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    // if (nextProps.value !== this.props.value) { TODO should also check if options changed for this to work
    const option = nextProps.options.find(i => i.value === nextProps.value)
    if (option) {
      if (option.label !== this.state.label) this.setLabel(option.label)
    } else {
      this.setLabel(this.props.defaultLabel)
    }
    // }
  }

  setLabel = (label) => {
    this.setState({label})
  }

  render() {
    const {classes, title, modalTitle, options, lastAction, isLoading} = this.props
    const {label} = this.state
    return (
      <LoadingIndicator show={isLoading}>
        <Panel>
          <PanelItem>
            <div className={classes.Container}>
              <div>
                <div className={classes.TitleContainer}>
                  <Typography gutterBottom={true} variant={'body2'} style={{flex: 1}}>{title}</Typography>
                  <IconButton style={{width: 24, height: 24}} onClick={this.props.onOpen}>
                    <KeyboardArrowDownicon style={{width: 16, height: 16}}/>
                  </IconButton>
                </div>
                <div>
                  <Typography variant={'body1'} color={'textSecondary'}>{label}</Typography>
                </div>
              </div>
              <div>
                <Dialog open={this.props.open} onClose={this.props.onClose}>
                  <DialogTitle align={'center'}>{modalTitle}</DialogTitle>
                  <List>
                    {options.map(o => (
                      <ListItem key={o.value} button onClick={() => this.props.onSelect(o.value)} disabled={o.disabled}>
                        <ListItemText primary={o.label}/>
                      </ListItem>
                    ))}
                    {lastAction && (
                      <div className={classes.LastActionContainer}>
                        <Link onClick={lastAction.onClick}>{lastAction.label}</Link>
                      </div>
                    )}
                  </List>
                  <DialogActions>
                    <Button onClick={this.props.onCancel} color={'primary'}>Cancelar</Button>
                  </DialogActions>
                </Dialog>
              </div>
            </div>
          </PanelItem>
        </Panel>
      </LoadingIndicator>
    )
  }

}

export default withStyles(styles, {withTheme: true})(Selector)



// WEBPACK FOOTER //
// ./src/sections/flow/components/selector.jsx